export const ORDERS_RECOGNITION_DATA_ATTR = 'data-sidebar-name';
export const ORDERS_RECOGNITION_DATA_ATTR_VALUE = 'OrdersRecognition';
export const ORDERS_SEARCH_QUERY = 'order_search_query';
export const ORDERS_HIDE_PROCEEDED = 'hide_proceeded_orders';
export const ORDERS_TOAST_SCOPE = 'ordersRecognition';
export const DEFAULT_SUPPLIER = i18next.t('OrderRecognition.DefaultSupplier.text');
